import dynamic from 'next/dynamic';
import React from 'react';
import { useIntl } from 'react-intl';
import { CategoryEntity } from '../../../../interfaces/explore/CategoryEntity';
import { MerchantReviewsResponse } from '../../../../interfaces/merchants/reviews';
import Button, { ButtonSize } from '../../../../atoms/buttons/Button';
import ReviewList from '../../../../molecules/merchant/reviews/ReviewList';

import Heading from '../../../../atoms/Heading';
import BaseTemplate from '../../../../organisms/merchants/BaseTemplate';
import MerchantProfile from '../../../../molecules/merchant/MerchantProfile';
import css from './MerchantReviewsPage.module.scss';

import { ReviewReadMoreProps } from '../../../../molecules/merchant/reviews/ReviewReadMore';
import { MerchantDetail } from '../../../../interfaces/merchants';
import { buildSiteUrl } from 'src/utils/request-url';
const ReadMore = dynamic<ReviewReadMoreProps>(
  import('../../../../molecules/merchant/reviews/ReviewReadMore').then(
    (c) => c.default,
  ),
  {
    loading: () => <span />,
    ssr: false,
  },
);

export interface PageProps {
  max: number;
  merchantDetail: MerchantDetail;
  category: CategoryEntity;
  reviewsData: MerchantReviewsResponse;
  isCoubicApp: boolean;
}

const MerchantReviewsPage = (props: PageProps) => {
  const { merchantDetail, reviewsData, max } = props;
  const intl = useIntl();
  const reviews = reviewsData.data;

  if (!reviews || !merchantDetail.merchant_setting.is_customer_review_active) {
    // TODO: 404 or something
    // tslint:disable-next-line: no-null-keyword
    return null;
  }

  return (
    <div className={css.MerchantReviewsPage}>
      <BaseTemplate
        merchantDetail={merchantDetail}
        isCoubicApp={props.isCoubicApp}
      >
        <div className={css.MerchantReviewsPage__Content}>
          <Heading className={css.MerchantReviewsPage__Heading}>
            {intl.formatMessage({ id: 'reviews.title' })} (
            {merchantDetail.rate_count})
          </Heading>
          <ReviewList merchantDetail={merchantDetail} reviews={reviews} />
          {reviewsData.current_page < reviewsData.total_pages && (
            <ReadMore
              max={max}
              merchantDetail={merchantDetail}
              merchantReviews={reviewsData}
            />
          )}
          <div className={css.MerchantReviewsPage__MerchantProfileSection}>
            <Heading className={css.MerchantReviewsPage__Heading}>
              {intl.formatMessage(
                { id: 'merchants.details.storeData' },
                { displayName: merchantDetail.display_name },
              )}
            </Heading>
            <MerchantProfile merchantDetail={merchantDetail} />
            <div className={css.MerchantReviewsPage__BackToTopButtonSection}>
              <Button
                className_Deprecated={css.MerchantReviewsPage__BackToTopButton}
                isGhost={true}
                isFull={true}
                href={buildSiteUrl()}
                buttonSize={ButtonSize.Medium}
              >
                {intl.formatMessage({
                  id: 'merchants.details.backToMerchantTop',
                })}
              </Button>
            </div>
          </div>
        </div>
      </BaseTemplate>
    </div>
  );
};

export default MerchantReviewsPage;
